import './Loader.css'

export default function Loader() {
	return (
		<div className='loader_wrapper'>
			<div className="loader"></div>
		</div>
	)
}
